import { render, staticRenderFns } from "./DadosContratado.vue?vue&type=template&id=3c1ccfb6"
import script from "./DadosContratado.vue?vue&type=script&lang=js"
export * from "./DadosContratado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports